import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=4aaa3c22&"
import script from "./Polygon.vue?vue&type=script&lang=js&"
export * from "./Polygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports